export default __webpack_public_path__ + "static/media/review_eddie.3138b7af.svg";